<template>
    <layout>
    	<div class="row">
			<div class="col-sm-12">
				<form autocomplete="off"
                    method="post"
                    data-vv-scope="form"
                    @keyup.enter="onBeforeSaveItem"
                    @submit.prevent="">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-7">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-name"
                                    name="name"
                                    v-model.trim="form.name"
                                    v-validate="'required|min:3'"
                                    @blur="setAutomaticCode"
                                    :inputClasses="[{'is-invalid': fnHasError('name')}]"
                                    :error="fnFirstError('name')"
                                    :helpText="$t(`${pageID}.help.name`)">
                                    {{ $t(`${pageID}.model.name`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem || isPersistent || !isNew"
                                    :disabled="readonlyFormItem || isPersistent || !isNew"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-code"
                                    name="code"
                                    v-model.trim="form.code"
                                    v-lowercase
                                    v-validate="codeValidation"
                                    @input="()=>forceValidateField('url')"
                                    :inputClasses="[{'is-invalid': fnHasError('code')}]"
                                    :error="fnFirstError('code')"
                                    :helpText="$t(`${pageID}.help.code`)">
                                    {{ $t(`${pageID}.model.code`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    type="number"
                                    id="input-order"
                                    name="order"
                                    v-model.trim="form.order"
                                    v-validate="'required|integer|min_value:1'"
                                    :inputClasses="[{'is-invalid': fnHasError('order')}]"
                                    :error="fnFirstError('order')"
                                    :helpText="$t(`${pageID}.help.order`)">
                                    {{ $t(`${pageID}.model.order`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialTextarea
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-description"
                                    name="description"
                                    :rows="4"
                                    v-model.trim="form.description"
                                    v-validate="'min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('description')}]"
                                    :error="fnFirstError('description')"
                                    :helpText="$t(`${pageID}.help.description`)">
                                    {{ $t(`${pageID}.model.description`) }}
                                </MaterialTextarea>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialTextarea
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-keywords"
                                    name="keywords"
                                    :rows="4"
                                    v-model.trim="form.keywords"
                                    v-validate="'min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('keywords')}]"
                                    :error="fnFirstError('keywords')"
                                    :helpText="$t(`${pageID}.help.keywords`)">
                                    {{ $t(`${pageID}.model.keywords`) }}
                                </MaterialTextarea>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-guest"
                                    name="guest"
                                    label="name"
                                    :options="accessTypes"
                                    v-model.trim="form.guest"
                                    :reduce="option => option.code"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('guest')}]"
                                    :error="fnFirstError('guest')"
                                    :helpText="$t(`${pageID}.help.guest`)">
                                    {{ $t(`${pageID}.model.guest`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-home"
                                    name="home"
                                    label="name"
                                    :options="lists.onoff"
                                    v-model.trim="form.home"
                                    :reduce="option => option.bool"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('home')}]"
                                    :error="fnFirstError('home')"
                                    :helpText="$t(`${pageID}.help.home`)">
                                    {{ $t(`${pageID}.model.home`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="true"
                                    class="city-form-group city-bg"
                                    id="input-backoffice"
                                    name="backoffice"
                                    label="name"
                                    :options="lists.onoff"
                                    v-model.trim="form.backoffice"
                                    :reduce="option => option.bool"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('backoffice')}]"
                                    :error="fnFirstError('backoffice')"
                                    :helpText="$t(`${pageID}.help.backoffice`)">
                                    {{ $t(`${pageID}.model.backoffice`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-status"
                                    name="status"
                                    label="name"
                                    :options="lists.onoff"
                                    v-model.trim="form.status"
                                    :reduce="option => option.bool"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('status')}]"
                                    :error="fnFirstError('status')">
                                    {{ $t(`${pageID}.model.status`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-8">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem || isPersistent"
                                            :disabled="readonlyFormItem || isPersistent"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-url"
                                            name="url"
                                            v-model.trim="form.url"
                                            v-validate="urlValidation"
                                            @input="()=>forceValidateField('code')"
                                            :inputClasses="[{'is-invalid': fnHasError('url')}]"
                                            :error=" fnFirstError('url')"
                                            :helpText="`${this.pageID}.help.url`">
                                            {{ $t(`${pageID}.model.url`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <MaterialColorPicker
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-theme_color"
                                            name="theme_color"
                                            v-model.trim="form.theme_color"
                                            v-validate="'required|min:7|max:9'"
                                            :inputClasses="[{'is-invalid': fnHasError('theme_color') }]"
                                            :error="fnFirstError('theme_color')"
                                            :helpText="`${this.pageID}.help.theme_color`">
                                            {{ $t(`${pageID}.model.theme_color`) }}
                                        </MaterialColorPicker>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-icon"
                                            name="icon"
                                            v-model.trim="form.icon"
                                            v-validate="'min:3'"
                                            :inputClasses="[{'is-invalid': fnHasError('icon') }]"
                                            :error=" fnFirstError('icon')"
                                            :helpText="`${this.pageID}.help.icon`">
                                            {{ $t(`${pageID}.model.icon`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="row h-100 pb-3 image-container">
                                <div class="col-12">
                                    <div class="d-flex flex-column h-100 pb-sm-3">
                                        <UploadSingleImage
                                            :disabled="readonlyFormItem"
                                            v-model="form.image"
                                            imageClass="background-contain"
                                            name="image"
                                            v-validate="''">
                                        </UploadSingleImage>
                                        <small v-if="fnFirstError('image')" class="d-block invalid-feedback">{{ fnFirstError('image') }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="onBeforeSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)">
                    </buttons-footer>
                </form>
			</div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin from '../../mixin'
    import { slugify } from '@config/utils';

  	export default {
  		mixins: [
            GeneralMixin
        ],
        components: {
            MaterialColorPicker: () => import(/* webpackChunkName: "color-picker" */ '@/components/form/MaterialColorPicker'),
            UploadSingleImage: () => import(/* webpackChunkName: "upload-single-image" */ '@/components/form/UploadSingleImage'),
        },
    	data() {
      		return {
      			pageID: 'modules',
        		form: {
				    id: null,
				    code: null,
				    code_alias: null,
				    name: null,
				    description: null,
				    keywords: null,
				    order: 1,
				    home: true,
				    backoffice: false,
				    guest: true,
				    status: true,
				    url: null,
				    icon: null,
				    image: null,
				    text_color: null,
				    theme_color: null,
				    persistent: 0,
	            },
      		}
    	},
		computed: {
            accessTypes() {
                return [
                    {id: 1, name: this.$t(`${this.pageID}.help.public`), code: true},
                    {id: 2, name: this.$t(`${this.pageID}.help.private`), code: false}
                ];
            },
            isNew() {
                return !!!this.form.id;
            },
            isPersistent() {
                return !!this.form.persistent;
            },
            codeValidation() {
                return { 'required': !this.form.url, 'min': 2, 'max': 30, 'regex': /^[a-z0-9-_]+$/i };
            },
            urlValidation() {
                return { 'required': !this.form.code, 'url': true };
            }
        },
        methods: {
            callbackLoadItem: function() {
                // Temporary solution
                if(this.form.icon) {
                    this.form.icon = this.resetUrlAPI(this.form.icon);
                }
            },
            forceValidateField: function(name) {
                this.validateField(name);
            },
            onBeforeSaveItem: function() {
                if(this.canEdit || this.canAdd) {
                    this.onSaveItem().then(res => {
                        let success = res == true || [200, 201].includes(res?.status);
                        if(success && this.$auth) {
                            this.$auth.fetch();
                        }
                    })
                }
            },
            setAutomaticCode: function() {
                let name = this.form.name;
                if(name && !this.form.code) {
                    this.form.code = slugify(name);
                    this.setFieldDirty('code');
                    this.resetFieldValidator('code');
                    // tem de ser juntamente com o URL porque a validação do code depende do url
                    this.resetFieldValidator('url');
                }
            }
        },
  	}
</script>

<style lang="sass" scoped>
.image-container {
    min-height: 150px;
}
</style>
